import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { AlertTriangle, Wifi, Globe, Home } from "lucide-react";

const Danger = () => {
  const [publicIP, setPublicIP] = useState("");
  const [localIPs, setLocalIPs] = useState([]);

  // Get Public IP
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setPublicIP(data.ip))
      .catch(() => setPublicIP("Unable to fetch"));
  }, []);

  // Get Local IP using WebRTC
  useEffect(() => {
    const getLocalIPs = async () => {
      const ips = [];
      try {
        const pc = new RTCPeerConnection({ iceServers: [] });
        pc.createDataChannel("");
        pc.createOffer()
          .then((offer) => pc.setLocalDescription(offer))
          .catch(() => {});
        pc.onicecandidate = (event) => {
          if (event && event.candidate && event.candidate.candidate) {
            const ipRegex =
              /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9:]+:+[a-f0-9]+)/g;
            const ip = event.candidate.candidate.match(ipRegex);
            if (ip) {
              ip.forEach((item) => {
                if (!ips.includes(item)) ips.push(item);
              });
            }
          }
        };
        setTimeout(() => {
          setLocalIPs(ips.length ? ips : ["Unable to fetch local IP"]);
          pc.close();
        }, 1000);
      } catch {
        setLocalIPs(["Unable to fetch local IP"]);
      }
    };
    getLocalIPs();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50 p-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-white shadow-2xl rounded-2xl p-8 max-w-md w-full border-2 border-red-500"
      >
        <div className="flex items-center gap-3 mb-4">
          <AlertTriangle className="text-red-600 w-8 h-8" />
          <h1 className="text-2xl font-bold text-red-700">Danger Zone</h1>
        </div>
        <p className="text-gray-600 mb-6">
          ⚠️ Warning! This page shows your **IP information**. Handle it
          carefully.
        </p>

        <div className="space-y-4">
          {/* Public IP Section */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="bg-red-100 p-4 rounded-xl flex items-center gap-3"
          >
            <Globe className="text-red-600 w-6 h-6" />
            <div>
              <p className="text-sm text-gray-500">Public IP</p>
              <p className="text-lg font-semibold text-red-700">{publicIP}</p>
            </div>
          </motion.div>

          {/* Local IP Section */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="bg-yellow-100 p-4 rounded-xl flex items-start gap-3"
          >
            <Home className="text-yellow-600 w-6 h-6" />
            <div>
              <p className="text-sm text-gray-500">Local IP(s)</p>
              {localIPs.map((ip, index) => (
                <p key={index} className="text-lg font-semibold text-yellow-700">
                  {ip}
                </p>
              ))}
            </div>
          </motion.div>

          {/* Network Icon Section */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="bg-orange-100 p-4 rounded-xl flex items-center gap-3"
          >
            <Wifi className="text-orange-600 w-6 h-6" />
            <div>
              <p className="text-sm text-gray-500">Connection</p>
              <p className="text-lg font-semibold text-orange-700">
                Active Network
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default Danger;